import { render, staticRenderFns } from "./LanguageInfo.vue?vue&type=template&id=cede23bc"
import script from "./LanguageInfo.vue?vue&type=script&lang=ts"
export * from "./LanguageInfo.vue?vue&type=script&lang=ts"
import style0 from "./LanguageInfo.vue?vue&type=style&index=0&id=cede23bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports